import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './pages/login/login.component';
import { SharedModule } from '@app/shared/shared.module';
import { PasswordDialogComponent } from '@app/modules/auth/dialogs/password-dialog/password-dialog.component';

@NgModule({
  declarations: [
    LoginComponent,
    PasswordDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class AuthModule { }
